import React, { forwardRef, ReactNode } from 'react';
import { Flex as ChakraFlex, FlexProps } from '@chakra-ui/react';

interface Props extends Omit<FlexProps, `css`> {
  children?: ReactNode;
}

export const Flex = forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    return (
      <ChakraFlex ref={ref} {...props}>
        {children}
      </ChakraFlex>
    );
  }
);
export type { Props as FlexProps };
